import { ThemedGallery } from '@spp/ui-gallery';

import EditorialLabel from '@vg/editorial-label';
import Timestamp from '@vg/publication-timestamp';
import Byline from '../../local-components/article/Byline';
import Bundle from '../../local-components/article/Bundle';
import Comments from '../../local-components/article/Comments';
import ContactUs from '../../local-components/ContactUs';
import VgGoldCompetition from '../../local-components/article/VgGoldCompetition';
import EmbedWrapper from '../../local-components/article/EmbedWrapper';
import Factbox from '../../local-components/article/Factbox';
import GalleryImage from '../../local-components/article/GalleryImage';
import GalleryVideo from '../../local-components/article/GalleryVideo';
import LazyLoadedImage from '../../local-components/article/LazyLoadedImage';
import LazyLoadedVideo from '../../local-components/article/LazyLoadedVideo';
import LazyLoadedMapMapbox from '../../local-components/article/LazyLoadedMapMapbox';
import Salesposter from '../../local-components/article/Salesposter';
import Streamer from '../../local-components/article/Streamer';
import ActionableText from '../../local-components/article/ActionableText';
import Tags from '../../local-components/article/Tags';
import TextAd from '../../local-components/article/TextAd';
import Url from '../../local-components/Url';
import LazyLoadedTopObject from '../../local-components/article/LazyLoadedTopObject';
import NtDisclaimer from '../../local-components/article/NtDisclaimer';
import CoreComments from '../../local-components/article/CoreComments';

const factboxEngagementTracking = ({ elementName, args }) => {
    const event = args[0];
    const toggleButton = event.currentTarget;
    const opening = toggleButton.getAttribute('aria-expanded') === 'false';

    try {
        const activity = window.AutoTrack.activity();
        activity.events
            .trackEngagement(
                undefined,
                undefined,
                'Click',
                'FactBox',
                elementName,
                opening ? 'Open' : 'Close',
            )
            .send();
    } catch (err) {
        console.error(err); // eslint-disable-line no-console
    }
};

export default {
    url: {
        default: {
            component: Url,
        },
        datawrapper: { component: EmbedWrapper },
        'top-banner': { component: EmbedWrapper },
    },
    salesposter: {
        default: {
            component: Salesposter,
        },
    },
    streamer: {
        default: {
            component: Streamer,
        },
    },
    byline: {
        default: {
            component: Byline,
        },
    },
    text: {
        timestamp: {
            component: Timestamp,
        },
    },
    'editorial-label': {
        default: {
            component: EditorialLabel,
        },
    },
    comments: {
        default: {
            component: Comments,
        },
    },
    'core-comments': {
        default: {
            component: CoreComments,
        },
    },
    'actionable-text': {
        default: {
            component: ActionableText,
        },
    },
    image: {
        default: {
            component: LazyLoadedImage,
        },
    },
    fact: {
        default: {
            component: Factbox,
            props: {
                interaction: factboxEngagementTracking,
            },
        },
    },
    map: {
        default: {
            component: LazyLoadedMapMapbox,
        },
    },
    video: {
        default: {
            component: LazyLoadedVideo,
        },
    },
    tags: {
        default: {
            component: Tags,
        },
    },
    ad: {
        default: {
            component: TextAd,
        },
    },
    'tip-us': {
        default: {
            component: ContactUs,
        },
    },
    'vg-gold-competition': {
        default: {
            component: VgGoldCompetition,
        },
    },
    gallery: {
        default: {
            component: ThemedGallery,
            children: {
                image: {
                    default: {
                        component: GalleryImage,
                    },
                },
                video: {
                    default: {
                        component: GalleryVideo,
                    },
                },
            },
        },
    },
    bundle: {
        default: {
            component: Bundle,
        },
    },
    top_object: {
        default: {
            component: LazyLoadedTopObject,
        },
    },
    'nt-disclaimer': {
        default: {
            component: NtDisclaimer,
        },
    },
};



/** WEBPACK FOOTER **
 ** ./src/screens/article/article-component-mapping.js
 **/